import { TranslatableKey } from '@app/types/translatable.type';

export const RqRemittanceFrequencies: { [key: string]: TranslatableKey } = {
    annual: 'company.payroll-info-rq-form.annual',
    quarterly: 'company.payroll-info-cra-form.quarterly',
    monthly: 'company.payroll-info-cra-form.monthly',
    twice_monthly: 'company.payroll-info-rq-form.twiceMonthly',
    weekly: 'company.payroll-info-rq-form.weekly',
};
